import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheck, FaTimes, FaShoppingCart, FaCalendarAlt } from 'react-icons/fa';
import './CartAddedToast.css';

/**
 * @param {{
 *   toast: {
 *     name: string,
 *     isRepeat: boolean,
 *     cartCount: number,
 *     key: number,
 *     kind?: 'cart' | 'subscription',
 *   } | null,
 *   onDismiss: () => void,
 * }} props
 */
export function CartAddedToast({ toast, onDismiss }) {
  if (!toast) {
    return null;
  }

  const isSubscription = toast.kind === 'subscription';
  const title = toast.isRepeat
    ? 'Added another'
    : (isSubscription ? 'Added to plan' : 'Added to cart');
  const itemLabel = toast.name.length > 48 ? `${toast.name.slice(0, 45)}…` : toast.name;
  const countLabel = isSubscription
    ? (toast.cartCount === 1 ? '1 item in subscription cart' : `${toast.cartCount} items in subscription cart`)
    : (toast.cartCount === 1 ? '1 item in cart' : `${toast.cartCount} items in cart`);

  return (
    <div
      className={`cart-added-toast${isSubscription ? ' cart-added-toast--plan' : ''}`}
      role="status"
      aria-live="polite"
      aria-atomic="true"
      key={toast.key}
    >
      <div className="cart-added-toast__icon" aria-hidden>
        <FaCheck />
      </div>
      <div className="cart-added-toast__body">
        <p className="cart-added-toast__title">
          {title} <strong>{itemLabel}</strong>
        </p>
        <p className="cart-added-toast__meta">{countLabel}</p>
      </div>
      <Link
        to={isSubscription ? '/subscription-cart' : '/cart'}
        className="cart-added-toast__cta"
        onClick={onDismiss}
      >
        {isSubscription ? <FaCalendarAlt aria-hidden /> : <FaShoppingCart aria-hidden />}
        {isSubscription ? 'View plan' : 'View cart'}
      </Link>
      <button
        type="button"
        className="cart-added-toast__dismiss"
        onClick={onDismiss}
        aria-label="Dismiss notification"
      >
        <FaTimes aria-hidden />
      </button>
    </div>
  );
}
